import { CERT_PIDS } from '~constants/codef';

interface CertInfo {
  usetype: string;
  organization: string;
}

/**
 * 공동인증서의 cert.extension.policyid값으로 usetype, organization을 반환
 * @param policyId
 * @returns
 *
 * @example
 * ```typescript
 * //Input
 * getCertInfo("1.2.410.200004.5.4.1.102")
 *
 * //Output
 * {
 *  "usetype":"증권거래용",
 *  "organization":"한국 전자인증"
 * }
 *
 * ```
 */
export default function getCertInfo(policyId: string): CertInfo {
  return (CERT_PIDS[policyId] ?? {
    usetype: '',
    organization: '',
  }) as unknown as CertInfo;
}
